export default __webpack_public_path__ + "static/media/template-img-2-large.61fea675.jpg";